module.exports = __webpack_public_path__ + "img/bart.7f5c1e59.jpg";